import {combineReducers} from 'redux';
import listingReducer from './listingReducer';
import { baseQueryAPI } from '../../services/baseQuery';


const rootReducer = combineReducers({
    listingReducer: listingReducer,
    [baseQueryAPI.reducerPath]: baseQueryAPI.reducer
})
export default rootReducer;
//export type RootState = ReturnType<typeof rootReducer>
